<div class="container-fluid">
  <div class="row">
    <div class="col">
      <h3>Departments</h3>
    </div>
    <div class="col">
      <button
        class="btn btn-raised btn-success float-right"
        (click)="addDepartment()"
      >
        New Department
      </button>
    </div>
  </div>

  <div class="row mt-3" *ngIf="loading">
    <div class="col text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>

  <div class="row ml-2 mt-3" *ngIf="!loading && departments.length === 0">
    <div class="flex-col pt-2">
      <i>No departments to display</i>
    </div>
  </div>

  <table class="table mt-3 text-left" *ngIf="!loading && departments.length > 0">
    <tbody>
      <tr>
        <th>Name</th>
        <th>Description</th>
        <th>Icon</th>
        <th>Enabled</th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
      <tr *ngFor="let department of departments">
        <td>
          {{ department.name }}
        </td>
        <td>
          {{ department.description || 'No description' }}
        </td>
        <td>
          <span
            class="material-icons"
            *ngIf="department.iconUrl"
            title="{{ department.iconUrl }}"
          >{{ department.iconUrl }}</span>
          <span *ngIf="!department.iconUrl" class="text-muted">No icon</span>
        </td>
        <td>
          {{ department.isEnabled ? 'Yes' : 'No' }}
        </td>
        <td>
          <ng-container *ngIf="department.isEnabled">
            <button
              class="btn btn-raised btn-danger"
              (click)="toggleDepartmentStatus(department)"
            >
              Disable
            </button>
          </ng-container>
          <ng-container *ngIf="!department.isEnabled">
            <button
              class="btn btn-raised btn-primary"
              (click)="toggleDepartmentStatus(department)"
            >
              Enable
            </button>
          </ng-container>
        </td>
        <td>
          <button
            class="btn btn-primary btn-sm"
            (click)="editDepartment(department)"
          >
            Edit
          </button>
        </td>
        <td>
          <wm-modal-confirm
            [showButtonText]="true"
            [showButton]="true"
            buttonText="Delete"
            commandText="Delete"
            title="Delete Department"
            (accepted)="deleteDepartment(department)"
            btnColor="danger"
            buttonClass="btn btn-danger btn-sm"
            [closeOnAccept]="true"
          >
            Are you sure you want to delete the department "{{ department.name }}"? This action cannot be undone.
          </wm-modal-confirm>
        </td>
      </tr>
    </tbody>
  </table>
</div>
